import { SlideItemType } from '@llx/common';
import { isSlideItemTextAnswerItem } from '@llx/common';
import { QuestionSlideItemType } from '@llx/common';

import { AnswerFieldsFragment, AnswerRelationUserFragment } from '@/@generated/codegen/API';

type AnswerStats = {
  userNames: string[];
};

export type SlideVotingStats = {
  totalSelectableAnswerVotes: number;
  selectableAnswers: Map<string, AnswerStats>;
  textAnswers: Map<string, AnswerStats>;
};

const getSlideVotingStats = (
  items: QuestionSlideItemType[],
  answers: (AnswerFieldsFragment & AnswerRelationUserFragment)[]
) => {
  const stats: SlideVotingStats = {
    totalSelectableAnswerVotes: answers.reduce((acc, curr) => {
      return acc + curr.answerIndexes!.length;
    }, 0),
    selectableAnswers: new Map(),
    textAnswers: new Map(),
  };
  const slideTextAnswerItems = items.filter(isSlideItemTextAnswerItem);
  items.forEach((item) => {
    if (item.type === SlideItemType.ANSWER_SELECTABLE) {
      stats.selectableAnswers.set(item.id, {
        userNames: answers
          .filter((answer) => answer.answerIndexes!.includes(item.id))
          .map((answer) => {
            return answer.user.email;
          }),
      });
    }
    if (item.type === SlideItemType.ANSWER_TEXT) {
      //NOTE: we need the index of the item in the array ONLY containing texts
      const idx = slideTextAnswerItems.findIndex((i) => i.id === item.id);
      stats.textAnswers.set(item.id, {
        userNames: answers
          .filter((answer) => answer.answerTexts![idx] !== '')
          .map((answer) => answer.user.email),
      });
    }
  });

  return stats;
};

export default getSlideVotingStats;

export const getDefaultSlideVotingStats = (items: QuestionSlideItemType[]): SlideVotingStats => ({
  totalSelectableAnswerVotes: 0,
  selectableAnswers: new Map(
    items
      .filter((item) => item.type === SlideItemType.ANSWER_SELECTABLE)
      .map((item) => [item.id, { userNames: [] }])
  ),
  textAnswers: new Map(
    items
      .filter((item) => item.type === SlideItemType.ANSWER_TEXT)
      .map((item) => [item.id, { userNames: [] }])
  ),
});
